export enum STATIC_DATA_TYPE {
  PAYOFFS = 'payoffs',
  CAPITAL_PROTECTION = 'capitalProtection',
  UKSPA_CODES = 'ukspaCodes',
  UNDERLYINGS = 'underlyings',
  ISSUERS = 'issuers',
  LANGUAGE = 'language',
  CREDIT_RATING_DESCRIPTIONS = 'creditRatingDescriptions',
  CREDIT_RATING_OUTLOOKS = 'creditRatingOutlooks',
  DEFAULT_RISK_DESCRIPTIONS = 'defaultRiskDescriptions',
  TRADING_CALENDARS = 'tradingCalendars',
  SETTLEMENT_CALENDARS = 'settlementCalendars',
  TARGET_MARKETS = 'targetMarkets',
  REFERENCE_ENTITY = 'referenceEntity',
  REFERENCE_OBLIGATION = 'referenceObligation',
  AGENTS = 'agents',
  ISSUERS_ENTITY = 'issuersEntity',
  LEGAL_PROGRAMMES = 'legalProgrammes',
  LISTING_VENUES = 'listingVenues',
  CURRENCIES = 'currency',
  PHYSICAL_SETTLEMENT_MATRIX = 'physicalSettlementMatrix',
  UNDERLYING_ASSETS = 'underlyingAssets',
  EXCHANGES = 'exchanges',
  DATA_INGESTION_CONFIG = 'dataIngestionConfig',
  DATA_EXPORT_FORMATS = 'dataExportFormats',
  DESKS = 'desks',
  CONTACTS = 'contacts',
  HURDLES_AND_SPREADS = 'hurdlesAndSpreads',
  DISTRIBUTOR_GROUPS = 'distributorGroups',
  DISTRIBUTORS = 'distributors',
  LEGAL_ENTITY = 'legalEntity',
  BENEFIT_KEY = 'benefitKey',
  PRODUCT_SUB_TYPE = 'productSubType',
  DATA_DICTIONARY = 'dataDictionary',
  RECURRING_FEE = 'recurringFee',
}


export enum STATIC_DATA_PERMISSION_TYPE {
  ISSUER = 'issuers',
  LANGUAGE = 'language',
  TRADING_CALENDAR = 'tradingCalendars',
  REFERENCE_ENTITY = 'referenceEntity',
  REFERENCE_OBLIGATION = 'referenceObligation',
  AGENT = 'agents',
  LEGAL_PROGRAMME = 'legalProgrammes',
  LISTING_VENUE = 'listingVenues',
  CURRENCIES = 'currency',
  PHYSICAL_SETTLEMENT_MATRIX = 'physicalSettlementMatrix',
  UNDERLYING_ASSET = 'underlyingAssets',
  EXCHANGE = 'exchanges',
  DATA_INGESTION_CONFIG = 'dataIngestionConfig',
  DATA_EXPORT_FORMAT = 'dataExportFormats',
  DESK = 'desks',
  CONTACT_PROFILE = 'contacts',
  DISTRIBUTOR_GROUP = 'distributorGroups',
  DISTRIBUTOR = 'distributors',
  LEGAL_ENTITY = 'legalEntity',
  BENEFIT_KEY = 'benefitKey',
  PRODUCT_SUBTYPE = 'productSubType',
  DATA_DICTIONARY = 'dataDictionary',
  RECURRING_FEE_CONFIG = 'recurringFee',
}

export const STATIC_DATA_PERMISSIONS: {[key in STATIC_DATA_TYPE]: string} = {
  [STATIC_DATA_TYPE.LANGUAGE]: 'LANGUAGE',
  [STATIC_DATA_TYPE.TRADING_CALENDARS]: 'TRADING_CALENDAR',
  [STATIC_DATA_TYPE.SETTLEMENT_CALENDARS]: 'TRADING_CALENDAR',
  [STATIC_DATA_TYPE.REFERENCE_ENTITY]: 'REFERENCE_ENTITY',
  [STATIC_DATA_TYPE.REFERENCE_OBLIGATION]: 'REFERENCE_OBLIGATION',
  [STATIC_DATA_TYPE.AGENTS]: 'AGENT',
  [STATIC_DATA_TYPE.CURRENCIES]: 'CURRENCIES',
  [STATIC_DATA_TYPE.ISSUERS]: 'ISSUER',
  [STATIC_DATA_TYPE.ISSUERS_ENTITY]: 'ISSUER',
  [STATIC_DATA_TYPE.LEGAL_PROGRAMMES]: 'LEGAL_PROGRAMME',
  [STATIC_DATA_TYPE.LISTING_VENUES]: 'LISTING_VENUE',
  [STATIC_DATA_TYPE.PHYSICAL_SETTLEMENT_MATRIX]: 'PHYSICAL_SETTLEMENT_MATRIX',
  [STATIC_DATA_TYPE.UNDERLYING_ASSETS]: 'UNDERLYING_ASSET',
  [STATIC_DATA_TYPE.EXCHANGES]: 'EXCHANGE',
  [STATIC_DATA_TYPE.DATA_INGESTION_CONFIG]: 'DATA_INGESTION_CONFIG',
  [STATIC_DATA_TYPE.DATA_EXPORT_FORMATS]: 'DATA_EXPORT_FORMAT',
  [STATIC_DATA_TYPE.DESKS]: 'DESK',
  [STATIC_DATA_TYPE.CONTACTS]: 'CONTACT_PROFILE',
  [STATIC_DATA_TYPE.HURDLES_AND_SPREADS]: 'HURDLE_AND_SPREAD',
  [STATIC_DATA_TYPE.DISTRIBUTOR_GROUPS]: 'DISTRIBUTOR_GROUP',
  [STATIC_DATA_TYPE.DISTRIBUTORS]: 'DISTRIBUTOR',
  [STATIC_DATA_TYPE.LEGAL_ENTITY]: 'LEGAL_ENTITY',
  [STATIC_DATA_TYPE.BENEFIT_KEY]: 'BENEFIT_KEY',
  [STATIC_DATA_TYPE.PRODUCT_SUB_TYPE]: 'PRODUCT_SUBTYPE',
  [STATIC_DATA_TYPE.DATA_DICTIONARY]: 'DATA_DICTIONARY',
  [STATIC_DATA_TYPE.RECURRING_FEE]: "RECURRING_FEE_CONFIG",
  // DATA BELLOW NOT IN USE
  [STATIC_DATA_TYPE.PAYOFFS]: '',
  [STATIC_DATA_TYPE.CAPITAL_PROTECTION]: '',
  [STATIC_DATA_TYPE.UKSPA_CODES]: '',
  [STATIC_DATA_TYPE.UNDERLYINGS]: '',
  [STATIC_DATA_TYPE.CREDIT_RATING_DESCRIPTIONS]: '',
  [STATIC_DATA_TYPE.CREDIT_RATING_OUTLOOKS]: '',
  [STATIC_DATA_TYPE.DEFAULT_RISK_DESCRIPTIONS]: '',
  [STATIC_DATA_TYPE.TARGET_MARKETS]: '',
}
